import EventBus from "@plugins/common/service/eventbus";

const recorderEventBus = new EventBus();
export default recorderEventBus;
